import { log } from "../../engine/logger/logger";
import { Actor } from "../actors/Actor";
import Colors from "../Colors";
import { gameData } from "../GameManager";

export const attackMsg = (actor: Actor, target: Actor, damage: number) => {
  log(
    actor === gameData.player
      ? `%c{${Colors.B_GREY_4}}${actor.breed.logName} hit ${target.breed.logName} for %c{${Colors.RED_4}}${damage}`
      : `%c{${Colors.B_GREY_4}}${actor.breed.logName} hits ${target.breed.logName} for %c{${Colors.RED_4}}${damage}`
  );
};

export const staggeredMsg = (actor: Actor) => {
  log(
    actor === gameData.player
      ? `${actor.breed.logName} are %c{${Colors.BLUE_1}}staggered%c{} and unable to react.`
      : `${actor.breed.logName} is %c{${Colors.BLUE_1}}staggered%c{} and unable to react.`
  );
};

export const diedMsg = (actor: Actor) => {
  log(
    actor === gameData.player
      ? `${actor.breed.logName} have fallen in battle.`
      : `%c{${Colors.B_GREY_4}}${actor.breed.logName} has fallen in battle.`
  );
};

export const blockMsg = (actor: Actor, target: Actor, damage: number) => {
  log(
    target === gameData.player
      ? `${target.breed.logName} take %c{${Colors.RED_4}}${damage}%c{} damage blocking ${actor.breed.logName}'s attack.`
      : `${target.breed.logName} takes %c{${Colors.RED_4}}${damage}%c{} damage blocking your attack.`
  );
};

export const blockFailMsg = (actor: Actor) => {
  log(
    actor === gameData.player
      ? `The mighty blow is too much for you to block.`
      : `The might blow is too much for ${actor.breed.logName} to block`
  );
};

export const blockSuccMsg = (actor: Actor) => {
  log(
    actor === gameData.player
      ? `${actor.breed.logName} recoil from being blocked.`
      : `${actor.breed.logName} recoils from being blocked.`
  );
};
